export default {
  errorInfoCupo: false,
  msgErrorInfocupo: '',
  infoValidateDoc: null,
}
